export enum DocumentModelScope {
	DOCUMENT_FOLDER = 'DOCUMENT_FOLDER',
	DEVICE = 'DEVICE',
	RECORD = 'RECORD',
	MAINTENANCE_LOG_ENTRY = 'MAINTENANCE_LOG_ENTRY'
}
